const imageSlide =[
    {
        url: 'https://wallpaperaccess.com/full/533313.jpg'
    },

    {
        url: 'https://whatifgaming.com/wp-content/uploads/2021/08/Steve-Sitting-Down.jpg'
    },

    {
        url: 'https://images8.alphacoders.com/479/479393.jpg'
    },

    {
        url: 'https://fiverr-res.cloudinary.com/images/q_auto,f_auto/gigs/197992292/original/17863ca80bfa9a063fb4887f93f9605c1233127c/do-a-realistic-minecraft-4k-wallpaper.png'
    },

    {
        url: 'https://images.hdqwalls.com/wallpapers/minecraft-hd-qb.jpg'
    }
]
export default imageSlide;